import { injectChargePointApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/charge-point.service';
import { baseApi } from '@service/base.api';

export const chargePointApi = injectChargePointApi(baseApi);

export const {
  useGetPaginatedChargePointsQuery,
  useGetChargePointQuery,
  useCreateChargePointMutation,
  useUpdateChargePointMutation,
  usePutQrCodeMutation,
  useAddSubscriptionToChargePointMutation,
} = chargePointApi;
